
////review
const review_main = document.getElementById("bth_main_review");
/*
const bth_review_1 = document.getElementById("bth_review1");
const bth_review_2 = document.getElementById("bth_review2");
const bth_review_3 = document.getElementById("bth_review3");
const bth_review_4 = document.getElementById("bth_review4");
//const bth_review_5 = document.getElementById("bth_review5");
const review_btn1 = document.getElementById("bth_review1_btn");
const review_btn2 = document.getElementById("bth_review2_btn");
const review_btn3 = document.getElementById("bth_review3_btn");
const review_btn4 = document.getElementById("bth_review4_btn");
//const review_btn5 = document.getElementById("bth_review5_btn");
*/
const img_arr_left = document.getElementById("img_arr_left");
const img_arr_right = document.getElementById("img_arr_right");

const review_btn1 = document.getElementById("bth_review1_btn");
const review_btn2 = document.getElementById("bth_review2_btn");
const review_btn3 = document.getElementById("bth_review3_btn");
const review_btn4 = document.getElementById("bth_review4_btn");

const new_feedbacks =[];
var review_num = 0;


function rev_btn(id) {
  switch (id){
      case 0:
        review_btn1.className="scroll_btn_active"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_gr";
        break;
      case 1:
        review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_active"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_gr";
        break;
      case 2:
        review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_active"; review_btn4.className="scroll_btn_gr"; 
        break;
      case 3:
         review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_active";      
        break;
  }
  
}

function rev_btn1() {
   review_btn1.className="scroll_btn_active"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_gr";            
}
function rev_btn2() {
   review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_active"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_gr";            
}
function rev_btn3() {
   review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_active"; review_btn4.className="scroll_btn_gr";            
}
function rev_btn4() {
   review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_active";            
}
/*
function rev_btn5() {
   review_btn1.className="scroll_btn_gr"; review_btn2.className="scroll_btn_gr"; review_btn3.className="scroll_btn_gr"; review_btn4.className="scroll_btn_gr";            
}
*/
review_btn1.onclick = function() { 
  review_num=0; add_block("right");
}

review_btn2.onclick = function() {
  review_num=1; add_block("right");
}

review_btn3.onclick = function() {
  review_num=2; add_block("right");
}

review_btn4.onclick = function() { 
  review_num=3; add_block("right");
}
/*
review_btn5.onclick = function() { 
  review_main.style.animation="animatehidel 1s";
  setTimeout(function () { 
    review_main.innerHTML = bth_review_5.innerHTML; rev_btn5();
    review_main.style.animation="animateshowl 1s";
  }, 500);
}
*/

var count_rev =1;
/*
img_arr_left.onclick = function() {
  if (count_rev==1){ count_rev=5;}
  else {count_rev--;}
  review_main.style.animation="animatehidel 1s";
  setTimeout(function () {
    review_main.innerHTML = document.getElementById("bth_review"+count_rev).innerHTML;
    switch(count_rev){
      case 1: rev_btn1(); break;
      case 2: rev_btn2(); break;
      case 3: rev_btn3(); break;
      case 4: rev_btn4(); break;
      case 5: rev_btn5(); break;
    } 
    review_main.style.animation="animateshowl 1s";
  }, 5000);
}

img_arr_right.onclick = function() {
  if (count_rev==5){ count_rev=1;}
  else {count_rev++;}
  review_main.style.animation="animatehider 1s";
  setTimeout(function () {
    review_main.innerHTML = document.getElementById("bth_review"+count_rev).innerHTML;
    switch(count_rev){
      case 1: rev_btn1(); break;
      case 2: rev_btn2(); break;
      case 3: rev_btn3(); break;
      case 4: rev_btn4(); break;
      case 5: rev_btn5(); break;
    } 
    review_main.style.animation="animateshowr 1s";
  }, 500);
  
}
*/

function add_block(dir){
  rev_btn(review_num);
  (dir=="right") ? review_main.style.animation="animatehider 1s" :   review_main.style.animation="animatehidel 1s";
  setTimeout(function () {
    var feedbackdate = null;
    if ( new_feedbacks[review_num].type=='video' ) {
      feedbackdate = new Date(new_feedbacks[review_num].Vdate !== "NA" ? new_feedbacks[review_num].Vdate : new_feedbacks[review_num].date);
    }else {
      feedbackdate = new Date(new_feedbacks[review_num].date);
    }

    var month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][feedbackdate.getMonth()];
    var lastdate = month + ' ' + feedbackdate.getDate() + ', '+ feedbackdate.getFullYear();
    if ( new_feedbacks[review_num].type=='video' ) {
      review_main.innerHTML ='<iframe class="ifr_vid_review" src="'+new_feedbacks[review_num].feedback+'?enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>'+
      // '<div><h2>'+new_feedbacks[review_num].rate+'/5</h2>'+
      '<div><span class="bfirst_2sec_2sp2 translate">Customer review by '+new_feedbacks[review_num].name+'</span><br>'+
      '<strong class="translate" style="font-size: 16px;">'+lastdate+'</strong></div>';
    }else{
       review_main.innerHTML =
       '<strong class=" translate" style="font-size: 20px; text-transform: lowercase;">"'+new_feedbacks[review_num].feedback+'"</strong>'+
        '<div><h2>'+new_feedbacks[review_num].rate+'/5</h2>'+
        '<span class="bfirst_2sec_2sp2 translate">Customer review by '+new_feedbacks[review_num].name+'</span><br>'+
        '<strong class="translate" style="font-size: 16px;">'+lastdate+'</strong></div>';
    }
    onYouTubeIframeAPIReady;
    (dir=="right") ?  review_main.style.animation="animateshowr 1s" :    review_main.style.animation="animateshowl 1s";
   ;
  }, 500);
}

img_arr_right.onclick = function() {
  if(review_num==0){review_num=3;}
  else { review_num--; }
  add_block("left");
}

img_arr_left.onclick = function() {
  if(review_num==3 ){review_num=0;}
  else { review_num++; }
  add_block("right");
}

var lope = setInterval(function() {
  if(review_num==3){review_num=0;}
  else { review_num++; }
  add_block("right");
}, 100000);

review_main.onmouseover = function() { clearInterval(lope); };
review_main.onmouseout = function() { lope = setInterval(function() {
  if(review_num==3){review_num=0;}
  else { review_num++; }
  add_block("right");
}, 100000); };


//review
review_main.addEventListener('swiped-left', function(e) {
    img_arr_left.click();
});
review_main.addEventListener('swiped-right', function(e) {
    img_arr_right.click();
});
  
			

$.ajax({
   type : "GET", 
   url : "https://storage.googleapis.com/trustville-widgets/shop/c/3384/prod/widget_json_feedbacks.json", 
   success : function(res) { 
       let result = JSON.parse(res);
       //document.getElementById("rating_count_br").innerHTML = String(result.rating_count);
       document.getElementById("rating_average_br").innerHTML = String(result.rating_average);
   }, 
   error : function(res) { 
   } 
});


$.ajax({
         type : "GET", 
         url : "https://wizville.auzen.com/customers.json",
         success : function(res) { 
            let result = JSON.parse(JSON.stringify(res));
            
            for (var i=1 ; i<Object.keys(result).length+1 ; i++){
             if(result[i].rate >=4.5 && result[i].feedback.length > 35 && result[i].feedback.length <= 120 && result[i].product != "NA" && result[i].country != "NA")
               new_feedbacks.push(result[i]);
            }
                   
            if(new_feedbacks.length <5){
              for (var i=1 ; i<Object.keys(result).length+1 ; i++){
                 if(result[i].rate >=4.5 && result[i].feedback.length > 35 && result[i].feedback.length <= 80 && result[i].product != "NA" && result[i].country != "NA")
                   new_feedbacks.push(result[i]);
                }
              new_feedbacks = [...new Set(new_feedbacks)];
            }
              
              new_feedbacks.sort((a, b) => {
                    if (a.country === "United Kingdom" && b.country !== "United Kingdom") return -1;
                    if (b.country === "United Kingdom" && a.country !== "United Kingdom") return 1;     
                  
                    if (a.country === "United Kingdom" && b.country === "United Kingdom") {
                      const dateA = new Date(a.date);
                      const dateB = new Date(b.date);
                      if (dateA > dateB) return -1; 
                       if (dateA < dateB) return 1;
                    }     
                    return 0;
              });
              new_feedbacks.sort((a, b) => {
                    if (a.type === "video" && a.country === "United Kingdom" && (b.type !== "video" || b.country !== "United Kingdom" ) ) return -1;
                    if (b.type === "video" && b.country === "United Kingdom" && (a.type !== "video" || a.country !== "United Kingdom") ) return 1;     
                  
                    if (a.type === "video" && a.country === "United Kingdom" && b.type === "video" && b.country === "United Kingdom") {
                      const dateA = new Date(a.date);
                      const dateB = new Date(b.date);
                      if (dateA > dateB) return -1; 
                       if (dateA < dateB) return 1;
                    }             
                    return 0;
              });
            add_block("right");
         }, 
         error : function(res) { 
         } 
});
